// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"ff17b17d","130":"d8463f30","178":"89c7c498","200":"d5afa560","453":"8253e7ef","856":"479245c3","890":"e34482aa"}[chunkId] + ".chunk.js";
};